<template>
    <div class="sidebar leftNav bbf left">
        <div class="home pr">
            <span class="pa ico"></span>
            <router-link to="/member/info" class="green">账户首页</router-link>
        </div>
        <dl>
            <template v-if="companyData.length !== 0">
                <dt><i></i>会员中心</dt>
                <dd>
                    <router-link to="/member/cart" :class="getLink('/member/cart')">购物车</router-link>
                    <router-link to="/member/order-list" :class="getLink('/member/order-list')">订单列表</router-link>
                </dd>
                <dt><i></i>期货询价</dt>
                <dd>
                    <router-link to="/member/futures-inquiry" :class="getLink('/member/futures-inquiry')">询价信息</router-link>
                </dd>
                <dt><i></i>供应资源</dt>
                <dd>
                    <router-link to="/member/supplylist" :class="getLink('/member/supplylist')">关注信息</router-link>
                </dd>
                <dt><i></i>委托找货</dt>
                <dd>
                    <router-link to="/member/my-trust" :class="getLink('/member/my-trust')">我的找货</router-link>
                </dd>
                <dt><i></i>我要找车</dt>
                <dd>
                    <router-link to="/member/my-logistics" :class="getLink('/member/my-logistics')">我的找车</router-link>
                    <router-link to="/member/my-logisticsinquiry" :class="getLink('/member/my-logisticsinquiry')">找车报价</router-link>
                    <router-link to="/member/my-routeinquiry" :class="getLink('/member/my-routeinquiry')">固定线路报价</router-link>
                </dd>
            </template>
        </dl>
        <a class="quit" @click="logout">退出</a>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                companyData: ''
            }
        },

        activated() {
            let isLogin = Boolean(window.localStorage.getItem('userhashid'));

            if (!isLogin) {
                this.$router.push({ name: '001-2', params: {h: true} })
            } else {
                this.$http.get(this.ym_api + '/company/').then((resp) => {
//                    if (resp.data.hasOwnProperty('status')) {
//                        if (!resp.data.status) {
//                            this.warnMessage(resp.data.msg);
//                            window.localStorage.removeItem('userhashid');
//                            window.location = '/login'
//                        }
//                    } else {
//                        if (resp.data.results.length !== 0) {
//                            this.companyData = resp.data.results[0]
//                        }
//                    }
                    if (resp.data.results.length !== 0) {
                        this.companyData = resp.data.results[0]
                    }
                }).catch((error) => {
                    window.localStorage.removeItem('userhashid');
                    window.location = '/login';
                    console.log(error)
                })
            }
        },

        methods: {
            getLink(path) {
                return this.$route.fullPath === path ? 'current' : ''
            },

            logout() {
                window.localStorage.removeItem('userhashid');
                window.location = '/'
            },

            warnMessage(message) {
                this.$message({
                    message: '警告: ' + message,
                    type: 'warning'
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// sidebar.vue?9b47379a